module.exports = __webpack_public_path__ + "img/promotion1_roll1.67cb9c75.jpg";